import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../utils/httpCommon";

const initialState = {
    loading: false,
    users: [{}],
    error: ''
}

export const fetchUsers = createAsyncThunk('fetchUserList', async () => {

    return await axiosInstance.get('/user/list')
        .then((response) => {
            return response.data
        })
})

const userListSlice = createSlice({
    name: 'userList',
    initialState,
    reducers: {},
    extraReducers: (builder) => {

        builder
            .addCase(fetchUsers.pending, (state, action) => {
                state.loading = true
            })
            .addCase(fetchUsers.fulfilled, (state, action) => {
                state.loading = false
                state.users = action.payload
                state.error = ''
            })
            .addCase(fetchUsers.rejected, (state, action) => {
                state.loading = false
                state.users = []
                state.error = action.error.message!.toString()
            })
    }
})

export default userListSlice.reducer;